import React, { ReactNode } from 'react';
import styles from './Column.module.css';

type ColumnNumbers =
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '10'
  | '11'
  | '12';

interface ColumnProps {
  children: ReactNode;
  start?: ColumnNumbers;
  span?: ColumnNumbers;
}

function Column({ children, start, span = '1' }: ColumnProps) {
  return (
    <div
      className={styles.column}
      style={{
        gridColumn: start
          ? `col-start ${start} / span ${span}`
          : `span ${span}`,
      }}
    >
      {children}
    </div>
  );
}

export { Column };
export type { ColumnNumbers };
